import { ListColumn, ListDataColumn } from "../ListColumn";
import { MedicinalProductsListView } from "./MedicinalProductsListView";

export class DevelopmentProductEntityListView extends MedicinalProductsListView {

        constructor(items: any) {

            const itemFinderArrayColumns=[
                new ListColumn("Num", ListDataColumn.TEXT, "num"),
                new ListColumn("EV Code", ListDataColumn.TEXT, "ev_Code"),
                new ListColumn("Version", ListDataColumn.TEXT, "version"),
                new ListColumn("Full Presentation Name", ListDataColumn.TEXT, "productname"),
                new ListColumn("Product Code", ListDataColumn.TEXT, "productcode"),
                new ListColumn("Validated", ListDataColumn.YESNODATETIME, "validated"),
                new ListColumn("Nullified", ListDataColumn.YESNODATETIME, "stamp_nullif"),

            ];

            const itemFinderTreeColumns=[
                new ListColumn("EV Code", ListDataColumn.TEXT, "ev_Code"),
                new ListColumn("Version", ListDataColumn.TEXT, "version"),
                new ListColumn("Full Presentation Name", ListDataColumn.TEXT, "productname"),
                new ListColumn("Product Code", ListDataColumn.TEXT, "productcode"),
                new ListColumn("Validated", ListDataColumn.YESNODATETIME, "validated"),
                new ListColumn("Nullified", ListDataColumn.YESNODATETIME, "stamp_nullif"),
            ];

            super(items,itemFinderArrayColumns,itemFinderTreeColumns);


    }

}